// import React, { useState, useEffect } from 'react';
// import {
//     Box,
//     Typography,
//     IconButton,
//     useMediaQuery,
//     useTheme,
//     Card,
//     Grid,
//     Button,
//     Dialog,
//     DialogActions,
//     DialogContent,
//     DialogContentText,
//     DialogTitle,
//     Snackbar,
//     Alert,
//     LinearProgress,
//     Fade,
//     Paper,
//     Divider,
//     Slider,
//     TextField,
//     CardContent
// } from '@mui/material';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import { useNavigate } from 'react-router-dom';
// import { styled } from '@mui/material/styles';
// import { trackCTA } from '../../service/usercta';

// // Styled Components
// const StyledCard = styled(Card)(({ theme }) => ({
//     borderRadius: 16,
//     boxShadow: '0 8px 32px rgba(0, 0, 0, 0.05)',
//     padding: theme.spacing(4),
//     width: '100%',
//     margin: 0,
//     background: 'linear-gradient(145deg, #ffffff, #f8f9ff)',
//     position: 'relative',
//     overflow: 'visible',
//     '&:before': {
//         content: '""',
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         right: 0,
//         height: 4,
//         background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//         borderTopLeftRadius: 16,
//         borderTopRightRadius: 16
//     }
// }));

// const MoodButton = styled(Button)(({ theme, selected }) => ({
//     minWidth: 'auto',
//     height: 100,
//     display: 'flex',
//     flexDirection: 'column',
//     padding: theme.spacing(2),
//     borderRadius: 12,
//     transition: 'all 0.3s ease',
//     border: selected ? '2px solid #4C41FF' : '1px solid #e0e0e0',
//     backgroundColor: selected ? 'rgba(76, 65, 255, 0.05)' : '#fff',
//     '&:hover': {
//         transform: 'translateY(-4px)',
//         boxShadow: '0 6px 20px rgba(76, 65, 255, 0.15)',
//         backgroundColor: selected ? 'rgba(76, 65, 255, 0.08)' : '#f8f9ff'
//     },
//     '& .MuiButton-label': {
//         flexDirection: 'column',
//         gap: theme.spacing(0.5)
//     }
// }));

// // Mood Component
// const Mood = ({ onCheckIn }) => {
//     const [selectedMood, setSelectedMood] = useState(null);
//     const [energyLevel, setEnergyLevel] = useState(5);
//     const [additionalNotes, setAdditionalNotes] = useState('');
//     const [openConfirm, setOpenConfirm] = useState(false);
//     const [openSuccess, setOpenSuccess] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [currentTime, setCurrentTime] = useState('');
//     const [moodStats, setMoodStats] = useState({ total: 0, thisWeek: 0, dayStreak: 0 });
//     const navigate = useNavigate();
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//     useEffect(() => {
//         // Set current time
//         const time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//         setCurrentTime(time);

//         // Load mood statistics
//         const moodData = JSON.parse(localStorage.getItem('echobuddy_mood_data') || '[]');
//         const today = new Date();
//         const oneWeekAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);

//         const thisWeekCount = moodData.filter(entry => {
//             const entryDate = new Date(entry.date);
//             return entryDate >= oneWeekAgo && entryDate <= today;
//         }).length;

//         // Calculate day streak
//         let dayStreak = 0;
//         const sortedData = moodData.sort((a, b) => new Date(b.date) - new Date(a.date));
//         const todayStr = today.toISOString().split('T')[0];

//         if (sortedData.length > 0 && sortedData[0].date === todayStr) {
//             dayStreak = 1;
//             for (let i = 1; i < sortedData.length; i++) {
//                 const currentDate = new Date(sortedData[i - 1].date);
//                 const prevDate = new Date(sortedData[i].date);
//                 const diffTime = currentDate - prevDate;
//                 const diffDays = diffTime / (1000 * 60 * 60 * 24);

//                 if (diffDays === 1) {
//                     dayStreak++;
//                 } else {
//                     break;
//                 }
//             }
//         }

//         setMoodStats({
//             total: moodData.length,
//             thisWeek: thisWeekCount,
//             dayStreak: dayStreak
//         });
//     }, []);

//     const moods = [
//         { emoji: "😊", label: "Happy", description: "Feeling joyful and content", color: "#4caf50", bgColor: "#e8f5e8", borderColor: "#4caf50" },
//         { emoji: "🤩", label: "Excited", description: "Enthusiastic and energized", color: "#ff9800", bgColor: "#fff3e0", borderColor: "#ff9800" },
//         { emoji: "😌", label: "Calm", description: "Peaceful and relaxed", color: "#2196f3", bgColor: "#e3f2fd", borderColor: "#2196f3" },
//         { emoji: "🧘", label: "Focused", description: "Concentrated and clear", color: "#9c27b0", bgColor: "#f3e5f5", borderColor: "#9c27b0" },
//         { emoji: "🙏", label: "Grateful", description: "Appreciative and thankful", color: "#8bc34a", bgColor: "#f1f8e9", borderColor: "#8bc34a" },
//         { emoji: "😐", label: "Neutral", description: "Balanced and steady", color: "#757575", bgColor: "#f5f5f5", borderColor: "#757575" },
//         { emoji: "😴", label: "Tired", description: "Low energy, need rest", color: "#795548", bgColor: "#efebe9", borderColor: "#795548" },
//         { emoji: "😰", label: "Stressed", description: "Feeling overwhelmed", color: "#f44336", bgColor: "#ffebee", borderColor: "#f44336" },
//         { emoji: "😟", label: "Anxious", description: "Worried or uneasy", color: "#ff5722", bgColor: "#fbe9e7", borderColor: "#ff5722" },
//         { emoji: "😢", label: "Sad", description: "Feeling down or blue", color: "#3f51b5", bgColor: "#e8eaf6", borderColor: "#3f51b5" },
//         { emoji: "😤", label: "Frustrated", description: "Annoyed or irritated", color: "#e91e63", bgColor: "#fce4ec", borderColor: "#e91e63" },
//         { emoji: "🤔", label: "Confused", description: "Uncertain or puzzled", color: "#00bcd4", bgColor: "#e0f2f1", borderColor: "#00bcd4" },
//     ];

//     // Slider marks
//     const energyMarks = [
//         { value: 1, label: '1 - Very Low' },
//         { value: 5, label: '5 - Moderate' },
//         { value: 10, label: '10 - Very High' }
//     ];

//     const handleCheckIn = () => {
//         setOpenConfirm(true);
//     };

//     const handleConfirm = async () => {
//         setOpenConfirm(false);
//         setLoading(true);

//         // Simulate API call
//         await new Promise(resolve => setTimeout(resolve, 1000));

//         setLoading(false);
//         setOpenSuccess(true);
//         if (onCheckIn) onCheckIn({ mood: selectedMood, energy: energyLevel, notes: additionalNotes });
//     };

//     const handleCloseConfirm = () => {
//         setOpenConfirm(false);
//     };

//     const handleCloseSuccess = () => {
//         setOpenSuccess(false);
//         navigate('/care');
//     };

//     const getGreeting = () => {
//         const hour = new Date().getHours();
//         if (hour < 12) return 'Good Morning';
//         if (hour < 18) return 'Good Afternoon';
//         return 'Good Evening';
//     };

//     return (
//         <Fade in={true} timeout={500}>
//             <Box>

//                 {/* Statistics Cards */}
//                 <Box sx={{ p: 3, pt: 0, bgcolor: '#f8f9fa' }}>
//                     <Box
//                         sx={{
//                             display: 'flex',
//                             flexWrap: 'wrap',
//                             justifyContent: 'center',
//                             gap: 2,
//                             maxWidth: 900,
//                             mx: 'auto',
//                         }}
//                     >
//                         <Box
//                             sx={{
//                                 flex: { xs: '1 1 100%', sm: '1 1 calc(33.333% - 16px)' },
//                             }}
//                         >
//                             <Card
//                                 sx={{
//                                     px: 4,
//                                     py: 2,
//                                     textAlign: 'center',
//                                     // bgcolor: '#d4edda',
//                                     background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                                     borderRadius: 2,
//                                     boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
//                                     minHeight: 80,
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     justifyContent: 'center',
//                                 }}
//                             >
//                                 <Typography
//                                     variant="h4"
//                                     sx={{ fontWeight: 700, color: '#fff', mb: 0.5, lineHeight: 1 }}
//                                 >
//                                     {moodStats.total}
//                                 </Typography>
//                                 <Typography
//                                     variant="caption"
//                                     sx={{
//                                         fontWeight: 600,
//                                         textTransform: 'uppercase',
//                                         letterSpacing: 0.5,
//                                         fontSize: '0.7rem',
//                                         color: '#fff'
//                                     }}
//                                 >
//                                     Total Check-ins
//                                 </Typography>
//                             </Card>
//                         </Box>

//                         <Box
//                             sx={{
//                                 flex: { xs: '1 1 100%', sm: '1 1 calc(33.333% - 16px)' },
//                             }}
//                         >
//                             <Card
//                                 sx={{
//                                     px: 4,
//                                     py: 2,
//                                     textAlign: 'center',
//                                     // bgcolor: '#d4edda',
//                                     background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                                     borderRadius: 2,
//                                     boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
//                                     minHeight: 80,
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     justifyContent: 'center',
//                                 }}
//                             >
//                                 <Typography
//                                     variant="h4"
//                                     sx={{ fontWeight: 700, color: '#fff', mb: 0.5, lineHeight: 1 }}
//                                 >
//                                     {moodStats.thisWeek}
//                                 </Typography>
//                                 <Typography
//                                     variant="caption"
//                                     sx={{
//                                         fontWeight: 600,
//                                         textTransform: 'uppercase',
//                                         letterSpacing: 0.5,
//                                         fontSize: '0.7rem',
//                                         color: '#fff',
//                                     }}
//                                 >
//                                     This Week
//                                 </Typography>
//                             </Card>
//                         </Box>

//                         <Box
//                             sx={{
//                                 flex: { xs: '1 1 100%', sm: '1 1 calc(33.333% - 16px)' },
//                             }}
//                         >
//                             <Card
//                                 sx={{
//                                     px: 4,
//                                     py: 2,
//                                     textAlign: 'center',
//                                     // bgcolor: '#d4edda',
//                                     background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                                     borderRadius: 2,
//                                     boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
//                                     minHeight: 80,
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     justifyContent: 'center',
//                                 }}
//                             >
//                                 <Typography
//                                     variant="h4"
//                                     sx={{ fontWeight: 700, color: '#fff', mb: 0.5, lineHeight: 1 }}
//                                 >
//                                     {moodStats.dayStreak}
//                                 </Typography>
//                                 <Typography
//                                     variant="caption"
//                                     sx={{
//                                         fontWeight: 600,
//                                         textTransform: 'uppercase',
//                                         letterSpacing: 0.5,
//                                         fontSize: '0.7rem',
//                                         color: '#fff'
//                                     }}
//                                 >
//                                     Day Streak
//                                 </Typography>
//                             </Card>
//                         </Box>
//                     </Box>

//                 </Box>

//                 <StyledCard elevation={0} sx={{ borderRadius: '0 0 16px 16px', mt: 0 }}>
//                     {/* Progress Bar */}
//                     {loading && <LinearProgress color="primary" sx={{ position: 'absolute', top: 0, left: 0, right: 0 }} />}

//                     {/* Mood Question */}
//                     <Box mb={4} textAlign="center">
//                         <Typography variant="h6" component="h2" sx={{
//                             fontWeight: 500,
//                             mb: 2,
//                             display: "flex",
//                             justifyContent: "flex-start"
//                         }}>
//                             How are you feeling right now?
//                         </Typography>
//                     </Box>

//                     {/* Mood Selection */}
//                     <Box mb={6}>
//                         <Grid container spacing={4} justifyContent="center">
//                             {moods.map((mood, idx) => (
//                                 <Grid item xs={6} sm={3} md={3} lg={3} key={idx}>
//                                     <Card
//                                         onClick={() => setSelectedMood(mood)}
//                                         sx={{
//                                             p: 2.5,
//                                             textAlign: 'center',
//                                             cursor: 'pointer',
//                                             borderRadius: 4,
//                                             height: 155,
//                                             width: '100%',
//                                             minWidth: 140,
//                                             bgcolor: mood.bgColor,
//                                             border:
//                                                 selectedMood?.label === mood.label
//                                                     ? `2px solid ${mood.borderColor}80` // same as hover
//                                                     : `1px solid ${mood.borderColor}40`,
//                                             boxShadow:
//                                                 selectedMood?.label === mood.label
//                                                     ? `0 4px 15px ${mood.borderColor}30` // same as hover
//                                                     : 'none',
//                                             transform: selectedMood?.label === mood.label ? 'translateY(-2px)' : 'none', // same as hover
//                                             transition: 'all 0.3s ease',
//                                             // '&:hover': {
//                                             //     transform: 'translateY(-2px)',
//                                             //     boxShadow: `0 4px 15px ${mood.borderColor}30`,
//                                             //     border: `2px solid ${mood.borderColor}80`
//                                             // }
//                                         }}
//                                     >
//                                         <Typography variant="h2" sx={{ mb: 1, fontSize: '2.5rem' }}>
//                                             {mood.emoji}
//                                         </Typography>
//                                         <Typography variant="subtitle1" sx={{
//                                             fontWeight: 700,
//                                             color: selectedMood?.label === mood.label ? mood.color : mood.color,
//                                             mb: 0.5,
//                                             fontSize: '1rem'
//                                         }}>
//                                             {mood.label}
//                                         </Typography>
//                                         <Typography variant="body2" sx={{
//                                             color: mood.color,
//                                             opacity: 0.8,
//                                             fontSize: '0.7rem',
//                                             lineHeight: 1.2,
//                                             px: 0.5
//                                         }}>
//                                             {mood.description}
//                                         </Typography>
//                                     </Card>
//                                 </Grid>
//                             ))}
//                         </Grid>
//                     </Box>

//                     {/* Energy Level Section */}
//                     <Box mb={6}>
//                         <Typography variant="h6" sx={{
//                             fontWeight: 500,
//                             mb: 3,
//                             textAlign: 'center'
//                         }}>
//                             What's your energy level?
//                         </Typography>
//                         <Card sx={{
//                             p: 4,
//                             bgcolor: energyLevel <= 3 ? '#ffebee' : energyLevel <= 7 ? '#fff3e0' : '#e8f5e8',
//                             borderRadius: 3,
//                             border: `2px solid ${energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50'}40`,
//                             transition: 'all 0.5s ease-in-out',
//                             transform: `scale(${1 + (energyLevel - 1) * 0.005})`,
//                             boxShadow: `0 4px 20px ${energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50'}20`
//                         }}>
//                             <Box textAlign="center" mb={3}>
//                                 <Typography variant="h6" sx={{
//                                     fontWeight: 600,
//                                     color: energyLevel <= 3 ? '#d32f2f' : energyLevel <= 7 ? '#f57c00' : '#2e7d32',
//                                     mb: 1,
//                                     transition: 'color 0.3s ease-in-out',
//                                     transform: energyLevel >= 8 ? 'scale(1.1)' : 'scale(1)',
//                                     animation: energyLevel >= 9 ? 'pulse 1.5s infinite' : 'none',
//                                     '@keyframes pulse': {
//                                         '0%': { transform: 'scale(1)' },
//                                         '50%': { transform: 'scale(1.05)' },
//                                         '100%': { transform: 'scale(1)' }
//                                     }
//                                 }}>
//                                     {energyLevel} - {energyLevel <= 3 ? 'Low Energy' : energyLevel <= 7 ? 'Moderate Energy' : 'High Energy'}
//                                     {energyLevel <= 2 && ' 😴'}
//                                     {energyLevel >= 3 && energyLevel <= 4 && ' 😐'}
//                                     {energyLevel >= 5 && energyLevel <= 7 && ' 🙂'}
//                                     {energyLevel >= 8 && energyLevel <= 9 && ' 😊'}
//                                     {energyLevel === 10 && ' 🔥'}
//                                 </Typography>
//                             </Box>
//                             <Box sx={{ px: 2 }}>
//                                 <Slider
//                                     value={energyLevel}
//                                     marks={energyMarks}
//                                     onChange={(e, value) => setEnergyLevel(value)}
//                                     min={1}
//                                     max={10}
//                                     step={1}
//                                     // marks={[
//                                     //     { value: 1, label: '1 - Very Low' },
//                                     //     { value: 5, label: '5 - Moderate' },
//                                     //     { value: 10, label: '10 - Very High' }
//                                     // ]}
//                                     sx={{
//                                         color: energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50',
//                                         transition: 'color 0.3s ease-in-out',
//                                         '& .MuiSlider-thumb': {
//                                             bgcolor: energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50',
//                                             width: energyLevel >= 8 ? 28 : 24,
//                                             height: energyLevel >= 8 ? 28 : 24,
//                                             transition: 'all 0.3s ease-in-out',
//                                             transform:
//                                                 energyLevel === 10
//                                                     ? 'translateY(-50%) scale(1.2)' // ✅ center vertically + scale
//                                                     : 'translateY(-50%) scale(1)',
//                                             boxShadow: `0 0 ${energyLevel * 2}px ${energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50'}60`,
//                                             // marginTop: '-13px',
//                                             '&:hover': {
//                                                 transform: 'translateY(-50%) scale(1.1)',
//                                                 boxShadow: `0 0 ${energyLevel * 3}px ${energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50'}80`
//                                             }
//                                         },
//                                         '& .MuiSlider-track': {
//                                             bgcolor: energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50',
//                                             height: energyLevel >= 8 ? 8 : 6,
//                                             transition: 'all 0.3s ease-in-out',
//                                             background: energyLevel >= 8 ?
//                                                 `linear-gradient(90deg, ${energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50'}, ${energyLevel <= 3 ? '#ff5722' : energyLevel <= 7 ? '#ffc107' : '#66bb6a'})` :
//                                                 energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50'
//                                         },
//                                         '& .MuiSlider-rail': {
//                                             bgcolor: '#e0e0e0',
//                                             height: 6
//                                         },
//                                         '& .MuiSlider-mark': {
//                                             bgcolor: energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50',
//                                             transition: 'background-color 0.3s ease-in-out'
//                                         },
//                                         // '& .MuiSlider-markLabel': {
//                                         //     fontSize: '0.75rem', // smaller font
//                                         //     transform: 'translateY(2px)', // moves them inside a bit
//                                         //     color: '#64748B',
//                                         // },
//                                         // // ✅ Shift the 3rd label left to 90%
//                                         // '& .MuiSlider-markLabel[data-index="2"]': {
//                                         //     left: '90% !important', // ✅ directly target the element with data-index="2"
//                                         // },
//                                         '& .MuiSlider-markLabel': {
//                                             fontSize: isMobile ? '0.65rem' : '0.75rem',
//                                             color: '#64748B',
//                                             whiteSpace: 'nowrap',
//                                         },
//                                         // Keep first label left-anchored, last label right-anchored so neither overflows
//                                         '& .MuiSlider-markLabel[data-index="0"]': {
//                                             transform: 'translateX(0%)',
//                                         },
//                                         '& .MuiSlider-markLabel[data-index="2"]': {
//                                             transform: 'translateX(-100%)',
//                                             left: 'auto !important',
//                                             right: 0,
//                                         },
//                                     }}
//                                 />
//                             </Box>
//                         </Card>
//                     </Box>

//                     {/* Additional Notes Section */}
//                     <Box mb={2}>
//                         <Typography variant="h6" sx={{
//                             fontWeight: 500,
//                             mb: 2,
//                             textAlign: 'center'
//                         }}>
//                             Additional Notes (Optional)
//                         </Typography>
//                         <TextField
//                             multiline
//                             rows={4}
//                             fullWidth
//                             placeholder="What's contributing to how you feel today? Any thoughts or observations about your mood..."
//                             value={additionalNotes}
//                             onChange={(e) => setAdditionalNotes(e.target.value)}
//                             sx={{
//                                 '& .MuiOutlinedInput-root': {
//                                     borderRadius: 3,
//                                     bgcolor: '#f8f9fa',
//                                     '&:hover fieldset': {
//                                         borderColor: '#4caf50'
//                                     },
//                                     '&.Mui-focused fieldset': {
//                                         borderColor: '#4caf50'
//                                     }
//                                 }
//                             }}
//                         />
//                     </Box>

//                     {/* Check-in Button */}
//                     <Box sx={{ textAlign: 'center', mt: 4, mb: 2 }}>
//                         {/* <Button
//                             variant="contained"
//                             size="large"
//                             onClick={handleCheckIn}
//                             disabled={!selectedMood || loading}
//                             sx={{
//                                 minWidth: 250,
//                                 borderRadius: 25,
//                                 py: 2,
//                                 px: 6,
//                                 fontSize: '1.1rem',
//                                 fontWeight: 600,
//                                 textTransform: 'none',
//                                 bgcolor: '#4caf50',
//                                 color: 'white',
//                                 boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)',
//                                 '&:hover': {
//                                     bgcolor: '#45a049',
//                                     boxShadow: '0 6px 20px rgba(76, 175, 80, 0.4)',
//                                     transform: 'translateY(-1px)'
//                                 },
//                                 '&.Mui-disabled': {
//                                     backgroundColor: '#f5f5f5',
//                                     color: '#bdbdbd'
//                                 }
//                             }}
//                         >
//                             {loading ? 'Recording Mood Check-in...' : 'Record Mood Check-in'}
//                         </Button> */}
//                         <Button
//                             variant="contained"
//                             size="medium"
//                             onClick={() => {
//                                 // 🔥 Track CTA event
//                                 const storedUser = localStorage.getItem('user');
//                                 const user = storedUser ? JSON.parse(storedUser) : null;

//                                 if (user && user.id) {
//                                     trackCTA('mood_checkin', user, window.location.pathname);
//                                     console.log(`✅ CTA tracked: mood_checkin`);
//                                 }

//                                 // Call the original handleCheckIn function
//                                 handleCheckIn();
//                             }}
//                             disabled={!selectedMood || loading}
//                             sx={{
//                                 minWidth: 180,
//                                 borderRadius: 1,
//                                 py: 1.2,
//                                 px: 3,
//                                 fontSize: '0.95rem',
//                                 fontWeight: 600,
//                                 textTransform: 'none',
//                                 background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                                 color: 'white',
//                                 boxShadow: '0 3px 10px rgba(76, 175, 80, 0.25)',
//                                 '&:hover': {
//                                     bgcolor: '#45a049',
//                                     boxShadow: '0 4px 15px rgba(76, 175, 80, 0.35)',
//                                     transform: 'translateY(-1px)',
//                                 },
//                                 '&.Mui-disabled': {
//                                     backgroundColor: '#f5f5f5',
//                                     color: '#bdbdbd',
//                                 },
//                             }}
//                         >
//                             {loading ? 'Recording Mood Check-in...' : 'Record Mood Check-in'}
//                         </Button>

//                     </Box>

//                     {/* Recent Mood History Section */}
//                     <Box>
//                         <Typography variant="h6" sx={{
//                             fontWeight: 700,
//                             mb: 2,
//                             textAlign: 'center'
//                         }}>
//                             Recent Mood History
//                         </Typography>
//                         <Card sx={{ px: 4, py: 3, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)', borderRadius: 3, textAlign: 'center', borderTop: '2px solid #e0e0e0', }}>
//                             <Typography variant="h6" sx={{ color: '#fff', mb: 2 }}>
//                                 🌱 Your mood tracking journey starts here!
//                             </Typography>
//                             <Typography variant="body1" sx={{ color: '#fff', fontStyle: 'italic' }}>
//                                 Complete your first check-in above to begin understanding your emotional patterns.
//                             </Typography>
//                         </Card>
//                     </Box>
//                 </StyledCard>

//                 {/* Confirmation Dialog */}
//                 <Dialog
//                     open={openConfirm}
//                     onClose={handleCloseConfirm}
//                     PaperProps={{
//                         sx: {
//                             borderRadius: 3,
//                             maxWidth: 400,
//                             width: '100%',
//                             p: 2
//                         }
//                     }}
//                 >
//                     <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
//                         <Typography variant="h6" fontWeight={600}>
//                             Confirm Your Mood
//                         </Typography>
//                     </DialogTitle>
//                     <DialogContent>
//                         <Box textAlign="center" py={2}>
//                             <Typography variant="h2" sx={{ mb: 2 }}>
//                                 {moods.find(m => m.label === selectedMood?.mood)?.emoji}
//                             </Typography>
//                             <Typography variant="body1" color="text.secondary">
//                                 You're feeling <strong>{selectedMood?.mood?.toLowerCase()}</strong> today.
//                             </Typography>
//                             <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontSize: '0.85rem' }}>
//                                 Energy Level: {energyLevel}/10
//                             </Typography>
//                         </Box>
//                     </DialogContent>
//                     <DialogActions sx={{ px: 3, pb: 3, justifyContent: 'center' }}>
//                         <Button
//                             onClick={handleCloseConfirm}
//                             variant="outlined"
//                             sx={{
//                                 mr: 2,
//                                 borderRadius: 2,
//                                 textTransform: 'none',
//                                 px: 3
//                             }}
//                         >
//                             Go Back
//                         </Button>
//                         <Button
//                             onClick={handleConfirm}
//                             variant="contained"
//                             autoFocus
//                             sx={{
//                                 borderRadius: 2,
//                                 textTransform: 'none',
//                                 px: 4,
//                                 bgcolor: '#4caf50',
//                                 '&:hover': {
//                                     bgcolor: '#45a049'
//                                 }
//                             }}
//                         >
//                             Yes, That's Right
//                         </Button>
//                     </DialogActions>
//                 </Dialog>

//                 {/* Success Snackbar */}
//                 <Snackbar
//                     open={openSuccess}
//                     autoHideDuration={3000}
//                     onClose={handleCloseSuccess}
//                     anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//                 >
//                     <Alert
//                         onClose={handleCloseSuccess}
//                         severity="success"
//                         sx={{
//                             width: '100%',
//                             borderRadius: 2,
//                             boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
//                         }}
//                     >
//                         <Box>
//                             <Typography variant="subtitle2" fontWeight={600}>
//                                 Check-in Complete! 🎉
//                             </Typography>
//                             <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                                 Your mood has been recorded successfully.
//                             </Typography>
//                         </Box>
//                     </Alert>
//                 </Snackbar>
//             </Box >
//         </Fade >
//     );
// };

// // Gratitude Component now imported from GratitudeJournal.jsx

// // Main Component
// const MoodCheckin = () => {
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//     const navigate = useNavigate();

//     const handleMoodCheckIn = (data) => {
//         console.log('Mood checked in:', data);

//         // Get existing mood data or initialize empty array
//         const moodData = JSON.parse(localStorage.getItem('echobuddy_mood_data') || '[]');
//         const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format

//         // Check if there's already an entry for today
//         const existingEntryIndex = moodData.findIndex(entry => entry.date === today);

//         const moodEntry = {
//             date: today,
//             mood: data.mood,
//             energy: data.energy,
//             notes: data.notes,
//             timestamp: new Date().toISOString()
//         };

//         if (existingEntryIndex >= 0) {
//             // Update existing entry for today
//             moodData[existingEntryIndex] = moodEntry;
//         } else {
//             // Add new entry
//             moodData.push(moodEntry);
//         }

//         // Save back to local storage
//         localStorage.setItem('echobuddy_mood_data', JSON.stringify(moodData));
//     };

//     return (
//         <Box sx={{
//             p: { xs: 2, sm: 4 },
//             maxWidth: 1800,
//             mx: 'auto',
//             minHeight: '100vh',
//             background: 'linear-gradient(180deg, #f8f9ff 0%, #ffffff 100%)'
//         }}>
//             {/* Header */}
//             <Box sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'space-between',
//                 mb: { xs: 3, sm: 4 },
//                 maxWidth: 1200,
//                 mx: 'auto',
//                 px: { xs: 0, sm: 2 }
//             }}>
//                 <Box>
//                     <Typography variant="h5" sx={{
//                         fontWeight: 700,
//                         color: 'text.primary',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: 1,
//                         background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
//                         WebkitBackgroundClip: 'text',
//                         WebkitTextFillColor: 'transparent',
//                     }}>
//                         Mood Check-in
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                         Track your emotional wellbeing
//                     </Typography>
//                 </Box>
//                 <IconButton
//                     onClick={() => navigate(-1)}
//                     sx={{
//                         backgroundColor: 'background.paper',
//                         width: 44,
//                         height: 44,
//                         borderRadius: '12px',
//                         boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
//                         '&:hover': {
//                             backgroundColor: 'action.hover',
//                             transform: 'translateY(-1px)'
//                         },
//                         transition: 'all 0.2s ease-in-out'
//                     }}
//                 >
//                     <ArrowBackIcon />
//                 </IconButton>
//             </Box>

//             {/* Mood Component */}
//             <Box sx={{
//                 mt: { xs: 2, sm: 0 },
//                 maxWidth: 900,
//                 mx: 'auto',
//                 position: 'relative',
//                 zIndex: 1
//             }}>
//                 <Mood onCheckIn={handleMoodCheckIn} />
//             </Box>

//             {/* Background Decorative Elements */}
//             <Box sx={{
//                 position: 'fixed',
//                 top: 0,
//                 right: 0,
//                 width: '40%',
//                 height: '100vh',
//                 background: 'radial-gradient(circle at 100% 0%, rgba(76, 65, 255, 0.05) 0%, rgba(76, 65, 255, 0) 70%)',
//                 zIndex: 0,
//                 pointerEvents: 'none'
//             }} />
//         </Box>
//     );
// };

// export default MoodCheckin;


import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    IconButton,
    useMediaQuery,
    useTheme,
    Card,
    Grid,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Snackbar,
    Alert,
    LinearProgress,
    Fade,
    Paper,
    Divider,
    Slider,
    TextField,
    CardContent
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { trackCTA } from '../../service/usercta';

// Styled Components
const StyledCard = styled(Card)(({ theme }) => ({
    borderRadius: 16,
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.05)',
    padding: theme.spacing(4),
    width: '100%',
    margin: 0,
    background: 'linear-gradient(145deg, #ffffff, #f8f9ff)',
    position: 'relative',
    overflow: 'visible',
    '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 4,
        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16
    }
}));

const MoodButton = styled(Button)(({ theme, selected }) => ({
    minWidth: 'auto',
    height: 100,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    borderRadius: 12,
    transition: 'all 0.3s ease',
    border: selected ? '2px solid #4C41FF' : '1px solid #e0e0e0',
    backgroundColor: selected ? 'rgba(76, 65, 255, 0.05)' : '#fff',
    '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: '0 6px 20px rgba(76, 65, 255, 0.15)',
        backgroundColor: selected ? 'rgba(76, 65, 255, 0.08)' : '#f8f9ff'
    },
    '& .MuiButton-label': {
        flexDirection: 'column',
        gap: theme.spacing(0.5)
    }
}));

// Mood Component
const Mood = ({ onCheckIn }) => {
    const [selectedMood, setSelectedMood] = useState(null);
    const [energyLevel, setEnergyLevel] = useState(5);
    const [additionalNotes, setAdditionalNotes] = useState('');
    const [openConfirm, setOpenConfirm] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [currentTime, setCurrentTime] = useState('');
    const [moodStats, setMoodStats] = useState({ total: 0, thisWeek: 0, dayStreak: 0 });
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        // Set current time
        const time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        setCurrentTime(time);

        // Load mood statistics
        const moodData = JSON.parse(localStorage.getItem('echobuddy_mood_data') || '[]');
        const today = new Date();
        const oneWeekAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);

        const thisWeekCount = moodData.filter(entry => {
            const entryDate = new Date(entry.date);
            return entryDate >= oneWeekAgo && entryDate <= today;
        }).length;

        // Calculate day streak
        let dayStreak = 0;
        const sortedData = moodData.sort((a, b) => new Date(b.date) - new Date(a.date));
        const todayStr = today.toISOString().split('T')[0];

        if (sortedData.length > 0 && sortedData[0].date === todayStr) {
            dayStreak = 1;
            for (let i = 1; i < sortedData.length; i++) {
                const currentDate = new Date(sortedData[i - 1].date);
                const prevDate = new Date(sortedData[i].date);
                const diffTime = currentDate - prevDate;
                const diffDays = diffTime / (1000 * 60 * 60 * 24);

                if (diffDays === 1) {
                    dayStreak++;
                } else {
                    break;
                }
            }
        }

        setMoodStats({
            total: moodData.length,
            thisWeek: thisWeekCount,
            dayStreak: dayStreak
        });
    }, []);

    const energyMarks = isMobile
        ? [
            { value: 1, label: 'Low' },
            { value: 5, label: 'Mid' },
            { value: 10, label: 'High' },
        ]
        : [
            { value: 1, label: '1 - Very Low' },
            { value: 5, label: '5 - Moderate' },
            { value: 10, label: '10 - Very High' },
        ];

    const moods = [
        { emoji: "😊", label: "Happy", description: "Feeling joyful and content", color: "#4caf50", bgColor: "#e8f5e8", borderColor: "#4caf50" },
        { emoji: "🤩", label: "Excited", description: "Enthusiastic and energized", color: "#ff9800", bgColor: "#fff3e0", borderColor: "#ff9800" },
        { emoji: "😌", label: "Calm", description: "Peaceful and relaxed", color: "#2196f3", bgColor: "#e3f2fd", borderColor: "#2196f3" },
        { emoji: "🧘", label: "Focused", description: "Concentrated and clear", color: "#9c27b0", bgColor: "#f3e5f5", borderColor: "#9c27b0" },
        { emoji: "🙏", label: "Grateful", description: "Appreciative and thankful", color: "#8bc34a", bgColor: "#f1f8e9", borderColor: "#8bc34a" },
        { emoji: "😐", label: "Neutral", description: "Balanced and steady", color: "#757575", bgColor: "#f5f5f5", borderColor: "#757575" },
        { emoji: "😴", label: "Tired", description: "Low energy, need rest", color: "#795548", bgColor: "#efebe9", borderColor: "#795548" },
        { emoji: "😰", label: "Stressed", description: "Feeling overwhelmed", color: "#f44336", bgColor: "#ffebee", borderColor: "#f44336" },
        { emoji: "😟", label: "Anxious", description: "Worried or uneasy", color: "#ff5722", bgColor: "#fbe9e7", borderColor: "#ff5722" },
        { emoji: "😢", label: "Sad", description: "Feeling down or blue", color: "#3f51b5", bgColor: "#e8eaf6", borderColor: "#3f51b5" },
        { emoji: "😤", label: "Frustrated", description: "Annoyed or irritated", color: "#e91e63", bgColor: "#fce4ec", borderColor: "#e91e63" },
        { emoji: "🤔", label: "Confused", description: "Uncertain or puzzled", color: "#00bcd4", bgColor: "#e0f2f1", borderColor: "#00bcd4" },
    ];

    const handleCheckIn = () => {
        setOpenConfirm(true);
    };

    const handleConfirm = async () => {
        setOpenConfirm(false);
        setLoading(true);

        // Simulate API call
        await new Promise(resolve => setTimeout(resolve, 1000));

        setLoading(false);
        setOpenSuccess(true);
        if (onCheckIn) onCheckIn({ mood: selectedMood, energy: energyLevel, notes: additionalNotes });
    };

    const handleCloseConfirm = () => {
        setOpenConfirm(false);
    };

    const handleCloseSuccess = () => {
        setOpenSuccess(false);
        navigate('/care');
    };

    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour < 12) return 'Good Morning';
        if (hour < 18) return 'Good Afternoon';
        return 'Good Evening';
    };

    return (
        <Fade in={true} timeout={500}>
            <Box>

                {/* Statistics Cards */}
                <Box sx={{ p: 3, pt: 0, bgcolor: '#f8f9fa' }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'center',
                            gap: 2,
                            maxWidth: 900,
                            mx: 'auto',
                        }}
                    >
                        <Box
                            sx={{
                                flex: { xs: '1 1 100%', sm: '1 1 calc(33.333% - 16px)' },
                            }}
                        >
                            <Card
                                sx={{
                                    px: 4,
                                    py: 2,
                                    textAlign: 'center',
                                    // bgcolor: '#d4edda',
                                    background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                    borderRadius: 2,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                    minHeight: 80,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                }}
                            >
                                <Typography
                                    variant="h4"
                                    sx={{ fontWeight: 700, color: '#fff', mb: 0.5, lineHeight: 1 }}
                                >
                                    {moodStats.total}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    sx={{
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        letterSpacing: 0.5,
                                        fontSize: '0.7rem',
                                        color: '#fff'
                                    }}
                                >
                                    Total Check-ins
                                </Typography>
                            </Card>
                        </Box>

                        <Box
                            sx={{
                                flex: { xs: '1 1 100%', sm: '1 1 calc(33.333% - 16px)' },
                            }}
                        >
                            <Card
                                sx={{
                                    px: 4,
                                    py: 2,
                                    textAlign: 'center',
                                    // bgcolor: '#d4edda',
                                    background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                    borderRadius: 2,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                    minHeight: 80,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                }}
                            >
                                <Typography
                                    variant="h4"
                                    sx={{ fontWeight: 700, color: '#fff', mb: 0.5, lineHeight: 1 }}
                                >
                                    {moodStats.thisWeek}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    sx={{
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        letterSpacing: 0.5,
                                        fontSize: '0.7rem',
                                        color: '#fff',
                                    }}
                                >
                                    This Week
                                </Typography>
                            </Card>
                        </Box>

                        <Box
                            sx={{
                                flex: { xs: '1 1 100%', sm: '1 1 calc(33.333% - 16px)' },
                            }}
                        >
                            <Card
                                sx={{
                                    px: 4,
                                    py: 2,
                                    textAlign: 'center',
                                    // bgcolor: '#d4edda',
                                    background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                    borderRadius: 2,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                    minHeight: 80,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                }}
                            >
                                <Typography
                                    variant="h4"
                                    sx={{ fontWeight: 700, color: '#fff', mb: 0.5, lineHeight: 1 }}
                                >
                                    {moodStats.dayStreak}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    sx={{
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        letterSpacing: 0.5,
                                        fontSize: '0.7rem',
                                        color: '#fff'
                                    }}
                                >
                                    Day Streak
                                </Typography>
                            </Card>
                        </Box>
                    </Box>

                </Box>

                <StyledCard elevation={0} sx={{ borderRadius: '0 0 16px 16px', mt: 0 }}>
                    {/* Progress Bar */}
                    {loading && <LinearProgress color="primary" sx={{ position: 'absolute', top: 0, left: 0, right: 0 }} />}

                    {/* Mood Question */}
                    <Box mb={4} textAlign="center">
                        <Typography variant="h6" component="h2" sx={{
                            fontWeight: 500,
                            mb: 2,
                            display: "flex",
                            justifyContent: "flex-start"
                        }}>
                            How are you feeling right now?
                        </Typography>
                    </Box>

                    {/* Mood Selection */}
                    <Box mb={6}>
                        <Grid container spacing={4} justifyContent="center">
                            {moods.map((mood, idx) => (
                                <Grid item xs={6} sm={3} md={3} lg={3} key={idx}>
                                    <Card
                                        onClick={() => setSelectedMood(mood)}
                                        sx={{
                                            p: 2.5,
                                            textAlign: 'center',
                                            cursor: 'pointer',
                                            borderRadius: 4,
                                            height: 155,
                                            width: '100%',
                                            minWidth: 140,
                                            bgcolor: mood.bgColor,
                                            border:
                                                selectedMood?.label === mood.label
                                                    ? `2px solid ${mood.borderColor}80` // same as hover
                                                    : `1px solid ${mood.borderColor}40`,
                                            boxShadow:
                                                selectedMood?.label === mood.label
                                                    ? `0 4px 15px ${mood.borderColor}30` // same as hover
                                                    : 'none',
                                            transform: selectedMood?.label === mood.label ? 'translateY(-2px)' : 'none', // same as hover
                                            transition: 'all 0.3s ease',
                                            // '&:hover': {
                                            //     transform: 'translateY(-2px)',
                                            //     boxShadow: `0 4px 15px ${mood.borderColor}30`,
                                            //     border: `2px solid ${mood.borderColor}80`
                                            // }
                                        }}
                                    >
                                        <Typography variant="h2" sx={{ mb: 1, fontSize: '2.5rem' }}>
                                            {mood.emoji}
                                        </Typography>
                                        <Typography variant="subtitle1" sx={{
                                            fontWeight: 700,
                                            color: selectedMood?.label === mood.label ? mood.color : mood.color,
                                            mb: 0.5,
                                            fontSize: '1rem'
                                        }}>
                                            {mood.label}
                                        </Typography>
                                        <Typography variant="body2" sx={{
                                            color: mood.color,
                                            opacity: 0.8,
                                            fontSize: '0.7rem',
                                            lineHeight: 1.2,
                                            px: 0.5
                                        }}>
                                            {mood.description}
                                        </Typography>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    {/* Energy Level Section */}
                    <Box mb={6}>
                        <Typography variant="h6" sx={{
                            fontWeight: 500,
                            mb: 3,
                            textAlign: 'center'
                        }}>
                            What's your energy level?
                        </Typography>
                        <Card sx={{
                            p: 4,
                            bgcolor: energyLevel <= 3 ? '#ffebee' : energyLevel <= 7 ? '#fff3e0' : '#e8f5e8',
                            borderRadius: 3,
                            border: `2px solid ${energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50'}40`,
                            transition: 'all 0.5s ease-in-out',
                            transform: `scale(${1 + (energyLevel - 1) * 0.005})`,
                            boxShadow: `0 4px 20px ${energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50'}20`
                        }}>
                            <Box textAlign="center" mb={3}>
                                <Typography variant="h6" sx={{
                                    fontWeight: 600,
                                    color: energyLevel <= 3 ? '#d32f2f' : energyLevel <= 7 ? '#f57c00' : '#2e7d32',
                                    mb: 1,
                                    transition: 'color 0.3s ease-in-out',
                                    transform: energyLevel >= 8 ? 'scale(1.1)' : 'scale(1)',
                                    animation: energyLevel >= 9 ? 'pulse 1.5s infinite' : 'none',
                                    '@keyframes pulse': {
                                        '0%': { transform: 'scale(1)' },
                                        '50%': { transform: 'scale(1.05)' },
                                        '100%': { transform: 'scale(1)' }
                                    }
                                }}>
                                    {energyLevel} - {energyLevel <= 3 ? 'Low Energy' : energyLevel <= 7 ? 'Moderate Energy' : 'High Energy'}
                                    {energyLevel <= 2 && ' 😴'}
                                    {energyLevel >= 3 && energyLevel <= 4 && ' 😐'}
                                    {energyLevel >= 5 && energyLevel <= 7 && ' 🙂'}
                                    {energyLevel >= 8 && energyLevel <= 9 && ' 😊'}
                                    {energyLevel === 10 && ' 🔥'}
                                </Typography>
                            </Box>
                            <Box sx={{ px: 2 }}>
                                <Slider
                                    value={energyLevel}
                                    marks={energyMarks}
                                    onChange={(e, value) => setEnergyLevel(value)}
                                    min={1}
                                    max={10}
                                    step={1}
                                    // marks={[
                                    //     { value: 1, label: '1 - Very Low' },
                                    //     { value: 5, label: '5 - Moderate' },
                                    //     { value: 10, label: '10 - Very High' }
                                    // ]}
                                    sx={{
                                        color: energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50',
                                        transition: 'color 0.3s ease-in-out',
                                        '& .MuiSlider-thumb': {
                                            bgcolor: energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50',
                                            width: energyLevel >= 8 ? 28 : 24,
                                            height: energyLevel >= 8 ? 28 : 24,
                                            transition: 'all 0.3s ease-in-out',
                                            transform:
                                                energyLevel === 10
                                                    ? 'translateY(-50%) scale(1.2)' // ✅ center vertically + scale
                                                    : 'translateY(-50%) scale(1)',
                                            boxShadow: `0 0 ${energyLevel * 2}px ${energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50'}60`,
                                            // marginTop: '-13px',
                                            '&:hover': {
                                                transform: 'translateY(-50%) scale(1.1)',
                                                boxShadow: `0 0 ${energyLevel * 3}px ${energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50'}80`
                                            }
                                        },
                                        '& .MuiSlider-track': {
                                            bgcolor: energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50',
                                            height: energyLevel >= 8 ? 8 : 6,
                                            transition: 'all 0.3s ease-in-out',
                                            background: energyLevel >= 8 ?
                                                `linear-gradient(90deg, ${energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50'}, ${energyLevel <= 3 ? '#ff5722' : energyLevel <= 7 ? '#ffc107' : '#66bb6a'})` :
                                                energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50'
                                        },
                                        '& .MuiSlider-rail': {
                                            bgcolor: '#e0e0e0',
                                            height: 6
                                        },
                                        '& .MuiSlider-mark': {
                                            bgcolor: energyLevel <= 3 ? '#f44336' : energyLevel <= 7 ? '#ff9800' : '#4caf50',
                                            transition: 'background-color 0.3s ease-in-out'
                                        },
                                        // '& .MuiSlider-markLabel': {
                                        //     fontSize: '0.75rem', // smaller font
                                        //     transform: 'translateY(2px)', // moves them inside a bit
                                        //     color: '#64748B',
                                        // },
                                        // // ✅ Shift the 3rd label left to 90%
                                        // '& .MuiSlider-markLabel[data-index="2"]': {
                                        //     left: '90% !important', // ✅ directly target the element with data-index="2"
                                        // },
                                        '& .MuiSlider-markLabel': {
                                            fontSize: isMobile ? '0.65rem' : '0.75rem',
                                            color: '#64748B',
                                            whiteSpace: 'nowrap',
                                        },
                                        // Keep first label left-anchored, last label right-anchored so neither overflows
                                        '& .MuiSlider-markLabel[data-index="0"]': {
                                            transform: 'translateX(0%)',
                                        },
                                        '& .MuiSlider-markLabel[data-index="2"]': {
                                            transform: 'translateX(-100%)',
                                            left: 'auto !important',
                                            right: 0,
                                        },
                                    }}
                                />
                            </Box>
                        </Card>
                    </Box>

                    {/* Additional Notes Section */}
                    <Box mb={2}>
                        <Typography variant="h6" sx={{
                            fontWeight: 500,
                            mb: 2,
                            textAlign: 'center'
                        }}>
                            Additional Notes (Optional)
                        </Typography>
                        <TextField
                            multiline
                            rows={4}
                            fullWidth
                            placeholder="What's contributing to how you feel today? Any thoughts or observations about your mood..."
                            value={additionalNotes}
                            onChange={(e) => setAdditionalNotes(e.target.value)}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: 3,
                                    bgcolor: '#f8f9fa',
                                    '&:hover fieldset': {
                                        borderColor: '#4caf50'
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#4caf50'
                                    }
                                }
                            }}
                        />
                    </Box>

                    {/* Check-in Button */}
                    <Box sx={{ textAlign: 'center', mt: 4, mb: 2 }}>
                        {/* <Button
                            variant="contained"
                            size="large"
                            onClick={handleCheckIn}
                            disabled={!selectedMood || loading}
                            sx={{
                                minWidth: 250,
                                borderRadius: 25,
                                py: 2,
                                px: 6,
                                fontSize: '1.1rem',
                                fontWeight: 600,
                                textTransform: 'none',
                                bgcolor: '#4caf50',
                                color: 'white',
                                boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)',
                                '&:hover': {
                                    bgcolor: '#45a049',
                                    boxShadow: '0 6px 20px rgba(76, 175, 80, 0.4)',
                                    transform: 'translateY(-1px)'
                                },
                                '&.Mui-disabled': {
                                    backgroundColor: '#f5f5f5',
                                    color: '#bdbdbd'
                                }
                            }}
                        >
                            {loading ? 'Recording Mood Check-in...' : 'Record Mood Check-in'}
                        </Button> */}
                        <Button
                            variant="contained"
                            size="medium"
                            onClick={() => {
                                // 🔥 Track CTA event
                                const storedUser = localStorage.getItem('user');
                                const user = storedUser ? JSON.parse(storedUser) : null;

                                if (user && user.id) {
                                    trackCTA('mood_checkin', user, window.location.pathname);
                                    console.log(`✅ CTA tracked: mood_checkin`);
                                }

                                // Call the original handleCheckIn function
                                handleCheckIn();
                            }}
                            disabled={!selectedMood || loading}
                            sx={{
                                minWidth: 180,
                                borderRadius: 1,
                                py: 1.2,
                                px: 3,
                                fontSize: '0.95rem',
                                fontWeight: 600,
                                textTransform: 'none',
                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                color: 'white',
                                boxShadow: '0 3px 10px rgba(76, 175, 80, 0.25)',
                                '&:hover': {
                                    bgcolor: '#45a049',
                                    boxShadow: '0 4px 15px rgba(76, 175, 80, 0.35)',
                                    transform: 'translateY(-1px)',
                                },
                                '&.Mui-disabled': {
                                    backgroundColor: '#f5f5f5',
                                    color: '#bdbdbd',
                                },
                            }}
                        >
                            {loading ? 'Recording Mood Check-in...' : 'Record Mood Check-in'}
                        </Button>

                    </Box>

                    {/* Recent Mood History Section */}
                    <Box>
                        <Typography variant="h6" sx={{
                            fontWeight: 700,
                            mb: 2,
                            textAlign: 'center'
                        }}>
                            Recent Mood History
                        </Typography>
                        <Card sx={{ px: 4, py: 3, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)', borderRadius: 3, textAlign: 'center', borderTop: '2px solid #e0e0e0', }}>
                            <Typography variant="h6" sx={{ color: '#fff', mb: 2 }}>
                                🌱 Your mood tracking journey starts here!
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#fff', fontStyle: 'italic' }}>
                                Complete your first check-in above to begin understanding your emotional patterns.
                            </Typography>
                        </Card>
                    </Box>
                </StyledCard>

                {/* Confirmation Dialog */}
                <Dialog
                    open={openConfirm}
                    onClose={handleCloseConfirm}
                    PaperProps={{
                        sx: {
                            borderRadius: 3,
                            maxWidth: 400,
                            width: '100%',
                            p: 2
                        }
                    }}
                >
                    <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
                        <Typography variant="h6" fontWeight={600}>
                            Confirm Your Mood
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Box textAlign="center" py={2}>
                            <Typography variant="h2" sx={{ mb: 2 }}>
                                {moods.find(m => m.label === selectedMood?.mood)?.emoji}
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                You're feeling <strong>{selectedMood?.mood?.toLowerCase()}</strong> today.
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontSize: '0.85rem' }}>
                                Energy Level: {energyLevel}/10
                            </Typography>
                        </Box>
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 3, justifyContent: 'center' }}>
                        <Button
                            onClick={handleCloseConfirm}
                            variant="outlined"
                            sx={{
                                mr: 2,
                                borderRadius: 2,
                                textTransform: 'none',
                                px: 3
                            }}
                        >
                            Go Back
                        </Button>
                        <Button
                            onClick={handleConfirm}
                            variant="contained"
                            autoFocus
                            sx={{
                                borderRadius: 2,
                                textTransform: 'none',
                                px: 4,
                                bgcolor: '#4caf50',
                                '&:hover': {
                                    bgcolor: '#45a049'
                                }
                            }}
                        >
                            Yes, That's Right
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Success Snackbar */}
                <Snackbar
                    open={openSuccess}
                    autoHideDuration={3000}
                    onClose={handleCloseSuccess}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <Alert
                        onClose={handleCloseSuccess}
                        severity="success"
                        sx={{
                            width: '100%',
                            borderRadius: 2,
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
                        }}
                    >
                        <Box>
                            <Typography variant="subtitle2" fontWeight={600}>
                                Check-in Complete! 🎉
                            </Typography>
                            <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                Your mood has been recorded successfully.
                            </Typography>
                        </Box>
                    </Alert>
                </Snackbar>
            </Box >
        </Fade >
    );
};

// Gratitude Component now imported from GratitudeJournal.jsx

// Main Component
const MoodCheckin = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();

    const handleMoodCheckIn = (data) => {
        console.log('Mood checked in:', data);

        // Get existing mood data or initialize empty array
        const moodData = JSON.parse(localStorage.getItem('echobuddy_mood_data') || '[]');
        const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format

        // Check if there's already an entry for today
        const existingEntryIndex = moodData.findIndex(entry => entry.date === today);

        const moodEntry = {
            date: today,
            mood: data.mood,
            energy: data.energy,
            notes: data.notes,
            timestamp: new Date().toISOString()
        };

        if (existingEntryIndex >= 0) {
            // Update existing entry for today
            moodData[existingEntryIndex] = moodEntry;
        } else {
            // Add new entry
            moodData.push(moodEntry);
        }

        // Save back to local storage
        localStorage.setItem('echobuddy_mood_data', JSON.stringify(moodData));
    };

    return (
        <Box sx={{
            p: { xs: 2, sm: 4 },
            maxWidth: 1800,
            mx: 'auto',
            minHeight: '100vh',
            background: 'linear-gradient(180deg, #f8f9ff 0%, #ffffff 100%)'
        }}>
            {/* Header */}
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: { xs: 3, sm: 4 },
                maxWidth: 1200,
                mx: 'auto',
                px: { xs: 0, sm: 2 }
            }}>
                <Box>
                    <Typography variant="h5" sx={{
                        fontWeight: 700,
                        color: 'text.primary',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }}>
                        Mood Check-in
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Track your emotional wellbeing
                    </Typography>
                </Box>
                <IconButton
                    onClick={() => navigate(-1)}
                    sx={{
                        backgroundColor: 'background.paper',
                        width: 44,
                        height: 44,
                        borderRadius: '12px',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
                        '&:hover': {
                            backgroundColor: 'action.hover',
                            transform: 'translateY(-1px)'
                        },
                        transition: 'all 0.2s ease-in-out'
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>
            </Box>

            {/* Mood Component */}
            <Box sx={{
                mt: { xs: 2, sm: 0 },
                maxWidth: 900,
                mx: 'auto',
                position: 'relative',
                zIndex: 1
            }}>
                <Mood onCheckIn={handleMoodCheckIn} />
            </Box>

            {/* Background Decorative Elements */}
            <Box sx={{
                position: 'fixed',
                top: 0,
                right: 0,
                width: '40%',
                height: '100vh',
                background: 'radial-gradient(circle at 100% 0%, rgba(76, 65, 255, 0.05) 0%, rgba(76, 65, 255, 0) 70%)',
                zIndex: 0,
                pointerEvents: 'none'
            }} />
        </Box>
    );
};

export default MoodCheckin;
